module.exports = __webpack_public_path__ + "media/A.041d993b.wav";